/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FuelType } from '../models/FuelType';
import type { NewCarVideoDto } from '../models/NewCarVideoDto';
import type { NewCarVideoDtoPagedListData } from '../models/NewCarVideoDtoPagedListData';
import type { NewCarVideoInput } from '../models/NewCarVideoInput';
import type { NewCarVideoPublishInput } from '../models/NewCarVideoPublishInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NewCarVideoService {

  /**
   * Получение списка new car video
   * @param modelId 
   * @param fuelTypeId
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param modelYear 
   * @param isActive 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns NewCarVideoDtoPagedListData Success
   * @throws ApiError
   */
  public static getNewCarVideos(
modelId?: number,
fuelTypeId?: FuelType,
modelYear?: string,
isActive?: boolean,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<NewCarVideoDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/new-car-videos',
      query: {
        'ModelId': modelId,
        'FuelTypeId': fuelTypeId,
        'ModelYear': modelYear,
        'IsActive': isActive,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Создание new car video
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postNewCarVideos(
requestBody?: NewCarVideoInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/new-car-videos',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * Получение new car video по Id
   * @param id 
   * @returns NewCarVideoDto Success
   * @throws ApiError
   */
  public static getNewCarVideos1(
id: number,
): CancelablePromise<NewCarVideoDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/new-car-videos/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Изменение new car video
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putNewCarVideos(
id: number,
requestBody?: NewCarVideoInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/new-car-videos/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Удаление new car video
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteNewCarVideos(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/new-car-videos/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Загрузка видео в new car video
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postNewCarVideosVideos(
id: number,
formData?: {
File: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/new-car-videos/{id}/videos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Удаление видео из new car video
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteNewCarVideosVideos(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/new-car-videos/{id}/videos',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Загрузка аудио в new car video
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postNewCarVideosAudios(
id: number,
formData?: {
File: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/new-car-videos/{id}/audios',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Удаление аудио из new car video
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteNewCarVideosAudios(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/new-car-videos/{id}/audios',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Загрузка и публикация на YouTube
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postNewCarVideosYouTube(
id: number,
requestBody?: NewCarVideoPublishInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/new-car-videos/{id}/you-tube',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

}
